module.exports = __webpack_public_path__ + "static/media/giftbox-white.90fb8b4.90fb8b44.svg";